import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { BaseService } from './base.service';
import { ResponseModel } from '../models/api.model';

import { MessageService } from 'primeng/api';
import { environment } from '../environments/environment';

@Injectable()
export class DetailService extends BaseService {

  constructor(private http: HttpClient, messageService: MessageService) {
    super(messageService);
  }

  order(id: string, includeInvoice = false) {
    let p: any = {};
    p.includeInvoice = includeInvoice;
    return this.search('order', id, p);
  }

  invoice(id: string, includeOrder = false) {
    let p: any = {};
    p.includeOrder = includeOrder;
    return this.search('invoice', id, p);
  }

  location(id: string) {
    return this.search('location', id);
  }

  user(id: string) {
    return this.search('user', id);
  }

  quote(id: string) {
    return this.search('quote', id);
  }

  private search(key: string, id: string, params: any = null) {
    return this.http.get(`${environment.baseUrl}api/detail/${key}/${id}`, { params: params })
      .pipe(map(res => {
        return <ResponseModel<any>>res;
      }));
  }
}
